import React, { useState, useEffect } from "react";
// mui
import { Card, CardContent, Typography, Grid, Skeleton } from "@mui/material";
// utils
import { userEngagement } from "../../../Utilities/dashboardSummary";

const EngagementCard = ({ name, count }) => (
  <Grid item xs={12} md={6}>
    <Card
      variant="outlined"
      sx={{
        mt: 1,
        border: "1px solid #1A1A1A",
        background: "#1A1A1A",
      }}
    >
      <CardContent>
        <Typography
          variant="body2"
          sx={{ fontSize: 14, fontWeight: 600, color: "#FFD700" }}
        >
          {name}
        </Typography>
        <Typography
          variant="body2"
          sx={{ fontSize: 24, fontWeight: 400, color: "#FFF", mt: 2 }}
        >
          {count ?? "N/A"}
        </Typography>
      </CardContent>
    </Card>
  </Grid>
);

const SkeletonCard = () => (
  <Grid item xs={12} md={6}>
    <Card
      variant="outlined"
      sx={{
        mt: 1,
        border: "1px solid #1A1A1A",
        background: "#1A1A1A",
      }}
    >
      <CardContent>
        <Skeleton width="60%" height={20} sx={{ mt: 1, background: "#fff" }} />
        <Skeleton width="40%" height={30} sx={{ mt: 1, background: "#fff" }} />
      </CardContent>
    </Card>
  </Grid>
);

export const UserEngagement = () => {
  const [loading, setLoading] = useState(true);
  const [responseData, setResponseData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await userEngagement();
        setResponseData(response);
      } catch (error) {
        console.error("Error fetching user engagement:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const rawData = responseData
    ? [
        { id: 1, name: "Yesterday", count: responseData.yesterdayUsersCount },
        { id: 2, name: "Last Week Avg", count: responseData.lastWeekAvgCount },
        { id: 3, name: "This Month", count: responseData.thisMonthUsersCount },
        { id: 4, name: "Last Month", count: responseData.lastMonthUsersCount },
      ]
    : [];

  return (
    <Card
      variant="outlined"
      sx={{ mt: 2, mb: 2, backgroundColor: "#242424", borderRadius: "8px" }}
    >
      <CardContent>
        <Typography
          gutterBottom
          variant="h5"
          sx={{ fontSize: 22, fontWeight: 500, color: "#FFF" }}
        >
          User Engagement
        </Typography>

        <Grid container spacing={2}>
          {["Daily Active Users (DAU)", "Monthly Active Users (MAU)"].map(
            (title, index) => (
              <Grid item xs={12} md={6} key={index}>
                <Typography
                  sx={{
                    mt: 1,
                    fontWeight: 400,
                    fontSize: "14px",
                    color: "rgba(255, 255, 255, 0.70)",
                  }}
                >
                  {title}
                </Typography>
                <Grid container spacing={2}>
                  {loading
                    ? [...Array(2)].map((_, i) => <SkeletonCard key={i} />)
                    : rawData
                        .slice(index * 2, index * 2 + 2)
                        .map((item) => (
                          <EngagementCard
                            key={item.id}
                            name={item.name}
                            count={item.count}
                          />
                        ))}
                </Grid>
              </Grid>
            )
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};
